import type { CanDeactivateFn } from '@angular/router';
import type { ProfileSettingsComponent } from '@/pages/profile/settings/profile-settings.component';

export const profileCanDeactivateGuard: CanDeactivateFn<ProfileSettingsComponent> = (component) =>
  component.canDeactivate();
